import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const Svg6Jaar = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M20 32c6.627 0 12-5.373 12-12S26.627 8 20 8 8 13.373 8 20s5.373 12 12 12"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.3 12.5A10.5 10.5 0 1 0 28.8 23h1a11.5 11.5 0 1 1-11.5-11.5z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M14.5 22.06a7.44 7.44 0 0 1 1.5-4.27l3.46-4.9 3 1.77-1.69 2.58h.11a4.61 4.61 0 0 1 4.61 4.59c0 3.15-2.25 5.28-5.52 5.28s-5.47-2.05-5.47-5.05m7 .06a1.54 1.54 0 1 0-3.08 0A1.44 1.44 0 0 0 20 23.75a1.45 1.45 0 0 0 1.54-1.63z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(Svg6Jaar);

export default ForwardRef;
